import { useState } from 'react';
import styled from 'styled-components';

const Backdrop = styled.div`
  position: fixed; inset: 0; background: rgba(0,0,0,0.35); display: grid; place-items: center; z-index: 500;
`;
const Modal = styled.div`
  width: 720px; background: #fff; border-radius: 16px; padding: 20px; box-shadow: 0 14px 32px rgba(0,0,0,0.18);
`;
const Row = styled.div` display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 10px; `;
const Actions = styled.div` display: flex; gap: 10px; justify-content: flex-end; margin-top: 10px; `;
const Label = styled.label`font-size:12px; color:#465676; display:block; margin-bottom:6px;`;
const Field = styled.input`
  width:100%; padding:10px 12px; border-radius:10px; border:1px solid #dbe3f6; background:#fff; color:#0b1221;
`;
const Select = styled.select`
  width:100%; padding:10px 12px; border-radius:10px; border:1px solid #dbe3f6; background:#fff; color:#0b1221;
`;
const FieldWrap = styled.div`
  margin-right: 20px;
`;
const Btn = styled.button`
  background:#fff; border:1px solid #dbe3f6; color:#0b1221; padding:8px 12px; border-radius:10px; cursor:pointer;
`;

type Props = {
  initial: { id: string; name?: string; email?: string; role?: string; isuNumber?: number; isuGroup?: string; verified?: boolean } | null;
  groupOptions?: string[];
  onClose: () => void;
  onSave: (payload: any) => Promise<void>;
};

export const UserEditModal = ({ initial, onClose, onSave, groupOptions = [] }: Props) => {
  const [name, setName] = useState(initial?.name ?? '');
  const [email, setEmail] = useState(initial?.email ?? '');
  const [role, setRole] = useState(initial?.role ?? '');
  const [isuNumber, setIsuNumber] = useState<string>((initial?.isuNumber ?? '').toString());
  const [isuGroup, setIsuGroup] = useState(initial?.isuGroup ?? '');
  const [verified, setVerified] = useState<boolean>(Boolean(initial?.verified ?? false));

  if (!initial) return null;

  const save = async () => {
    await onSave({ id: initial.id, name, email, role, isuNumber: isuNumber ? Number(isuNumber) : undefined, isuGroup, verified });
    onClose();
  };

  return (
    <Backdrop onClick={onClose}>
      <Modal onClick={e => e.stopPropagation()}>
        <h3>Редактирование пользователя</h3>
        <Row>
          <FieldWrap>
            <Label>Имя</Label>
            <Field placeholder="Имя" value={name} onChange={e => setName(e.target.value)} />
          </FieldWrap>
          <FieldWrap>
            <Label>Email</Label>
            <Field placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
          </FieldWrap>
          <FieldWrap>
            <Label>Роль</Label>
            <Select value={role} onChange={e => setRole(e.target.value)}>
              <option value="Student">Student</option>
              <option value="Mentor">Mentor</option>
              <option value="Teacher">Teacher</option>
              <option value="Admin">Admin</option>
            </Select>
          </FieldWrap>
          <FieldWrap>
            <Label>ИСУ</Label>
            <Field placeholder="ИСУ" value={isuNumber} onChange={e => setIsuNumber(e.target.value)} />
          </FieldWrap>
          <FieldWrap style={{gridColumn:'1 / span 2'}}>
            <Label>Группа ИСУ</Label>
            <Field placeholder="Группа ISU…" value={isuGroup} onChange={e => setIsuGroup(e.target.value)} list="modalGroups" />
            <datalist id="modalGroups">
              <option value="__none__">без группы</option>
              {groupOptions.map((g)=> (<option key={g} value={g} />))}
            </datalist>
          </FieldWrap>
          <FieldWrap style={{display:'flex', alignItems:'center'}}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" checked={verified} onChange={e => setVerified(e.target.checked)} /> Верифицирован
            </label>
          </FieldWrap>
        </Row>
        <Actions>
          <Btn onClick={onClose}>Отмена</Btn>
          <Btn onClick={save}>Сохранить</Btn>
        </Actions>
      </Modal>
    </Backdrop>
  );
};


